import {TextField, Typography} from "@mui/material";
import {connect} from "react-redux";
import IncrementDecrementInput from "./Atoms/IncrementDecrementInput";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription
  }) => ({
    i18n,
    isLoading,
    orderSubscription
  }),
  {
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;
  return (
    <div className="card-info">
      <Typography variant="h1">{i18n.select_package}</Typography>
      <p>
         Geben Sie hier
        an wieviele Pakete des oben gewählten Abos Sie benötigen.
      </p>
      
      <IncrementDecrementInput />
      <p className="text">Sie können 247Uptime für maximal {parseInt(props.orderSubscription.cost) * props.orderSubscription.userNumber} User nutzen.</p>
    </div>
  );
});
